<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/10MAUTL/tc-custom/9781642792461.jpg?1705037440534" alt="This image is the cover for the book Doctor Dilemma"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Doctor Dilemma
      </h1>
      <p class="bookDescription body article font2">
        <b><i>The Doctor Dilemma</i> is an easy-to-read book for busy physicians who are struggling with burnout, unhappiness, and career dissatisfaction, and may even be wondering if they made a mistake becoming a doctor.</b><p> Currently over 50% of physicians across all medical specialties are reporting symptoms of increasing stress and burnout. Sara Dill, MD has been there. She knows how painful it is to secretly wonder if all those years of school and training were a mistake. <i>The Doctor Dilemma</i> reminds doctors why they decided to go into medicine in the first place and helps them outline what their dream job looks like. This timely helper, written by a physician and certified life coach, outlines the tools and steps doctors can take to start feeling better, reverse burnout, and create the dream medical career and work-life balance they want. It’s time for doctors to become the happy and successful healers they always wanted to be.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sara Dill
      </h2>
      
      <p class="authorDescription body article">Sara Dill, MD is a physician, life coach, and consultant who specializes in working with unhappy physicians struggling with overwork, burnout, and career doubt and dissatisfaction. She has degrees from Harvard, the UC San Diego School of Medicine, and Brown Medical School. Sara practiced in a variety of clinical settings for eight years as a board-certified dermatologist and sub-specialty-trained and certified pediatric dermatologist. She currently lives in Santa Barbara, California, with the world’s laziest dog.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Morgan James Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4a11c27d